import { Component } from "@angular/core";

@Component({
  selector: "app-skeleton-sidebar",
  templateUrl: "./skeleton-sidebar.component.html",
  styleUrls: ["./skeleton-sidebar.component.scss"],
})
export class SkeletonSidebarComponent {}
